module.exports = __webpack_public_path__ + "static/citzbooking_img3-29a8e9c5cd5d04e376afa7c24a8af366.png";